import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ArchivosExpedienteService } from 'src/app/services/archivos-expediente/archivos-expediente.service';
import { URL_IMGS } from 'src/environments/environment';

@Component({
  selector: 'app-archivos-expediete',
  templateUrl: './archivos-expediete.component.html',
  styleUrls: ['./archivos-expediete.component.css'],
})
export class ArchivosExpedieteComponent implements OnInit {
  archivos_list: any[] = [];
  url = `${URL_IMGS}archivos_expediente`;
  expediente_id;
  constructor(
    private route: ActivatedRoute,
    private _archivosExpedienteService: ArchivosExpedienteService
  ) {}

  ngOnInit(): void {
    this.expediente_id = this.route.snapshot.paramMap.get('expediente_id');
    this.check_archicos_expediente();
  }
  check_archicos_expediente() {
    const condiciones = { absolutas: [{ expediente_id: this.expediente_id }] };
    this._archivosExpedienteService
      .filtrado(condiciones)
      .subscribe((res: any) => {
        console.log('OBTENIENDO ARCHIVOS', res);
        this.archivos_list = res.lista;
        this.archivos_list.forEach((item) => {
          let arr = item.nombre.split('_');
          let cad = null;
          arr.forEach((element) => {
            if (!!cad) cad += ' ' + element;
            else cad = element;
          });
          if (!item.nombre_mostrar) item.nombre_mostrar = cad;
        });
      });
  }
  url_file(id, item) {
    if (!`${item}`.includes("amazonaws"))
      return `${this.url}/${id}/${item}
  `;
    return item;
  }
}
